import {
  CONFIRMED_CREATE_PATIENT_MENOPAUSE_CHART,
  CONFIRMED_DELETE_PATIENT_MENOPAUSE_CHART,
  CONFIRMED_EDIT_PATIENT_MENOPAUSE_CHART,
  CONFIRMED_GET_PATIENT_MENOPAUSE_CHARTS,
  SET_MENOPAUSE_LOADING,
  SET_MENOPAUSE_ERROR,
} from "./PatientMenopauseType"

import {
  createPatientMenopauseChart,
  deletePatientMenopauseChart,
  updatePatientMenopauseChart,
  getPatientMenopauseChart,
  formatPatientMenopauseChart,
} from "../../services/PatientMenopauseService"

import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService"

// GET all entries
export function getPatientMenopauseChartAction(patient_id) {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: true })

      const response = await getPatientMenopauseChart(patient_id)

      if (response?.status === 200 && response.data?.status === "success") {
        const formattedData = formatPatientMenopauseChart(response.data.data)
        dispatch({ type: CONFIRMED_GET_PATIENT_MENOPAUSE_CHARTS, payload: formattedData })
      } else {
        dispatch({ type: SET_MENOPAUSE_ERROR, payload: "Failed to fetch menopause charts" })
        showErrorAlert("Failed to fetch menopause charts", "error")
      }
    } catch (error) {
      console.error("Error fetching menopause chart:", error)
      dispatch({ type: SET_MENOPAUSE_ERROR, payload: error.message })
      showErrorAlert("Something went wrong while fetching data", "error")
    } finally {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: false })
    }
  }
}

// CREATE entry - Fixed patient_id handling
export function createPatientMenopauseChartAction(chartData, patient_id) {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: true })

      // Ensure patient_id is properly included
      const payload = {
        patient_id: patient_id,
        menopause_date: chartData.menopause_date,
        age_first_m: chartData.age_first_m,
        menstruation: chartData.menstruation,
        how_long_m_stopped: chartData.how_long_m_stopped,
        causes_m: chartData.causes_m,
        other_name: chartData.other_name,
        how_many_days_occur: chartData.how_many_days_occur,
        by_patient: chartData.by_patient,
      }

      const response = await createPatientMenopauseChart(payload)

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({ type: CONFIRMED_CREATE_PATIENT_MENOPAUSE_CHART, payload: response.data.data })
        handleSuccess("Chart entry created successfully!", "success")
        return { success: true }
      } else {
        dispatch({ type: SET_MENOPAUSE_ERROR, payload: "Failed to create chart entry" })
        showErrorAlert("Failed to create chart entry", "error")
        return { success: false }
      }
    } catch (error) {
      console.error(error)
      dispatch({ type: SET_MENOPAUSE_ERROR, payload: error.message })
      showErrorAlert("Failed to create chart entry", "error")
      return { success: false }
    } finally {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: false })
    }
  }
}

// DELETE entry - Fixed to properly update state after deletion
export function deletePatientMenopauseChartAction(entry, patient_id) {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: true })

      // Only pass menopause_id for deletion
      const payload = {
        menopause_id: entry.menopause_id,
        patient_id:patient_id
      }

      const response = await deletePatientMenopauseChart(payload)

      if (response?.status === 200 && response.data?.status === "success") {
        // First dispatch the delete action to update the state
        dispatch({
          type: CONFIRMED_DELETE_PATIENT_MENOPAUSE_CHART,
          payload: { menopause_id: entry.menopause_id },
        })

        // Then refresh the data from server to ensure consistency
        setTimeout(() => {
          dispatch(getPatientMenopauseChartAction(patient_id))
        }, 100)

        handleSuccess("Chart entry deleted successfully!", "success")
        return { success: true }
      } else {
        dispatch({ type: SET_MENOPAUSE_ERROR, payload: "Failed to delete chart entry" })
        showErrorAlert("Failed to delete chart entry", "error")
        return { success: false }
      }
    } catch (error) {
      console.error("Delete error:", error)
      dispatch({ type: SET_MENOPAUSE_ERROR, payload: error.message })
      showErrorAlert("Failed to delete chart entry", "error")
      return { success: false }
    } finally {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: false })
    }
  }
}

// UPDATE entry - Fixed patient_id handling
export function updatePatientMenopauseChartAction(chartData, menopause_id, patient_id) {
  return async (dispatch) => {
    try {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: true })

      // Ensure all required fields including patient_id are included
      const payload = {
        menopause_id: menopause_id,
        patient_id: patient_id, // Make sure patient_id is included
        menopause_date: chartData.menopause_date,
        age_first_m: chartData.age_first_m,
        menstruation: chartData.menstruation,
        how_long_m_stopped: chartData.how_long_m_stopped,
        causes_m: chartData.causes_m,
        other_name: chartData.other_name,
        how_many_days_occur: chartData.how_many_days_occur,
      }

      const response = await updatePatientMenopauseChart(payload)

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({ type: CONFIRMED_EDIT_PATIENT_MENOPAUSE_CHART, payload: response.data.data })
        handleSuccess("Chart entry updated successfully!", "success")
        return { success: true }
      } else {
        dispatch({ type: SET_MENOPAUSE_ERROR, payload: "Failed to update chart entry" })
        showErrorAlert("Failed to update chart entry", "error")
        return { success: false }
      }
    } catch (error) {
      console.error(error)
      dispatch({ type: SET_MENOPAUSE_ERROR, payload: error.message })
      showErrorAlert("Failed to update chart entry", "error")
      return { success: false }
    } finally {
      dispatch({ type: SET_MENOPAUSE_LOADING, payload: false })
    }
  }
}
